export const normalizeString = (text: string): string => {
    if (!text) return "";

    const trMap: Record<string, string> = {
        'ç': 'c', 'Ç': 'c',
        'ğ': 'g', 'Ğ': 'g',
        'ş': 's', 'Ş': 's',
        'ü': 'u', 'Ü': 'u',
        'ı': 'i', 'I': 'i', 'İ': 'i', 'i': 'i',
        'ö': 'o', 'Ö': 'o'
    };

    return text.split('').map(char => trMap[char] || char).join('').toLowerCase();
};
